import React, { useState } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { FiShoppingCart } from 'react-icons/fi'
import logo from '../assets/imgs/DigitalContacts-logo.svg'
import { connect } from 'react-redux'
import { loginUser, verifyTotp } from '../actions/registerUser'
import Spinner from './Spinner'

const Login = ({ loginUser, verifyTotp, isAuth, user }) => {
  const [loginData, setLoginData] = useState({
    email: '',
    password: '',
  })
  const [pendingToken, setPendingToken] = useState(null)
  const [code, setCode] = useState('')
  const { email, password } = loginData
  const onChangeHandler = (e) =>
    setLoginData({ ...loginData, [e.target.name]: e.target.value })

  const onSubmitHandler = async (e) => {
    e.preventDefault()

    const result = await loginUser(email, password)
    if (result && result.pending) {
      setPendingToken(result.pendingToken)
    }
  }

  const onCodeSubmitHandler = async (e) => {
    e.preventDefault()
    // On success isAuth flips true via redux and this component
    // re-renders into the isAuth branch below. On failure verifyTotp
    // already alerts; the code screen just stays put for another try.
    await verifyTotp(pendingToken, code)
  }

  if (isAuth) {
    // isAdmin arrives on the user document, which loads asynchronously
    // right after login (isAuth flips true first) -- wait for it instead
    // of guessing, so an admin is never briefly routed into the normal
    // onboarding chain before the redirect corrects itself.
    if (!user) return <Spinner />
    if (user.isAdmin) return <Redirect to="/admin" />
    return <Redirect to="/add_profile_image" />
  }

  if (pendingToken) {
    return (
      <div class="my-name create-account wel-back">
        <div className="container">
          <div className="row">
            <form onSubmit={(e) => onCodeSubmitHandler(e)}>
              <div className="col-12">
                <div className="logo">
                  <img src={logo} alt="logo" />
                </div>
                <div className=" headline">
                  <h1>Enter your 6-digit code</h1>
                </div>
                <div className="headline">
                  <p className="p1">
                    Open your authenticator app and enter the current code.
                  </p>
                </div>
                <input
                  type="text"
                  name="code"
                  placeholder="123456"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength={6}
                  autoFocus
                  onChange={(e) => setCode(e.target.value)}
                  value={code}
                  required
                />
                <button
                  className="btn w-100prc"
                  type="submit"
                  style={{ marginTop: '14px' }}
                >
                  Verify
                </button>
                <span
                  className="forgot"
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setPendingToken(null)
                    setCode('')
                  }}
                >
                  Back to login
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div class="my-name create-account wel-back">
      <div className="container">
        <div className="row">
          <form onSubmit={(e) => onSubmitHandler(e)}>
            <div className="col-12">
              <div className="login1">
                <Link to="login" className="account1">
                  Got your card?
                </Link>
                {/* Straight to the shop. This used to open a popup whose
                    only content was a "Shop Now" button pointing here,
                    so the popup was a click in the way of its own link.
                    An <a> rather than the old <span>: .login1 a in
                    style.css already supplies the left margin and
                    text-decoration this needs. */}
                {/* Feather via react-icons, the set BackButton/
                    SocialEditor/ListItem already use -- no new
                    dependency, and it matches the icons elsewhere in the
                    app. (Font Awesome is loaded in index.html but not
                    referenced by a single class anywhere in src.)
                    inline-flex overrides .login1 a's inline-block so the
                    glyph and the label centre against each other. */}
                <a
                  href="https://digitalcontactcard.com/shop"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="log-in"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                  }}
                >
                  <FiShoppingCart size={14} aria-hidden="true" />
                  Get Now
                </a>
              </div>
              <div className="logo">
                <img src={logo} alt="logo" />
              </div>
              <div className=" headline">
                <h1>Welcome back, To Digital Contact Card!</h1>
              </div>
              <div className="headline">
                <p className="p1">
                  Enter your email address and password to access your account.
                </p>
              </div>
              <input
                type="email"
                name="email"
                placeholder="Email"
                onChange={(e) => onChangeHandler(e)}
                value={loginData.email}
                required
              />
              <input
                type="password"
                name="password"
                placeholder="Password"
                onChange={(e) => onChangeHandler(e)}
                value={loginData.password}
                required
              />
              <button
                className="btn w-100prc"
                type="submit"
                id="submitBtn"
                style={{ marginTop: '14px' }}
              >
                Log In
              </button>
              <Link to="reset_password" className="forgot">
                Forgot Password?
              </Link>
              {/* Leading slash, unlike the sibling links above: those
                  resolve relative to the current URL, which only works
                  because /login sits at the root. */}
              <span className="forgot">
                Don&rsquo;t have an account?{' '}
                <Link
                  to="/register"
                  style={{ color: '#000001', textDecoration: 'underline' }}
                >
                  Register
                </Link>
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  isAuth: state.registerUser.isAuth,
  user: state.registerUser.user,
})

export default connect(mapStateToProps, { loginUser, verifyTotp })(Login)
